import { jsx as _jsx } from "react/jsx-runtime";
import { Loader, LoaderContainer } from './styled';
export default function LoaderBig() {
    return (_jsx(LoaderContainer, { children: _jsx(Loader, {}) }));
}
